import { Box, Button, IconButton, Typography } from "@mui/material"
import { icons } from "../../../utils/icons"
import BaseModal from "../baseModal"
import { useStyles } from "./styles"
import { Props } from "./props"



const CrudModal = ({ open, close, title, buttonText, next, children, sx, disable, description }: Props) => {
  const styles = useStyles()
  return (
    <BaseModal open={open} sx={{ ...styles.baseModal, ...(sx ?? {}) } as object}>
      <Box sx={styles.containerSuccess}>
        <IconButton
            sx={styles.closeSuccess}
            onClick={() => {
                close()
            }}
        >
            {icons('simple-close')}
        </IconButton>
        <Box className="container">
          {!!title && <Box className="containarTitle"><Typography variant="blue_title">{title}</Typography></Box>}
          {!!description && <Typography className="subtitle">{description}</Typography>}
          {children}
        </Box>
        <Box sx={styles.buttonContainer}>
            <Button variant="contained"
                className="continue"
                disabled={disable}
                onClick={() => {
                    next()
                }}
            >
                {buttonText}
            </Button>
        </Box>
      </Box>
    </BaseModal>
  )
}

export default CrudModal
